import request from '@/plugins/axios'

//获取推送渠道列表
export function listPushChannel(params) {
  return request({
    url: '/pushChannel/listPushChannel',
    method: 'get',
    params
  })
}

//获取允许推送渠道列表
export function listAllowPushChannel() {
  return request({
    url: '/pushChannel/listAllowPushChannel',
    method: 'get'
  })
}

//添加推送渠道
export function addPushChannel(data) {
  return request({
    url: '/pushChannel/addPushChannel',
    method: 'post',
    data
  })
}

//删除推送渠道
export function deletePushChannel(params) {
  return request({
    url: '/pushChannel/deletePushChannel/' + params,
    method: 'get'
  })
}

//查询单个推送渠道
export function getPushChannel(params) {
  return request({
    url: '/pushChannel/getPushChannel/' + params,
    method: 'get'
  })
}

//修改推送渠道信息
export function updatePushChannel(data) {
  return request({
    url: '/pushChannel/updatePushChannel',
    method: 'post',
    data
  })
}

//获取推送渠道模板
export function getPowerTemplate() {
  return request({
    url: '/pushChannel/getChannelTemplate',
    method: 'get'
  })
}